
import { useEffect } from "react";
import { QUERY_VERSION } from "@/constants/serviceQueryConstants";

/**
 * Hook to reset toast flag and prefetched pages when parameters change
 */
export const useQueryReset = (
  searchQuery: string,
  activeSubcategoryId: number | null,
  selectedRegion: string,
  adjustedPageSize: number,
  page: number,
  setHasToasted: (value: boolean) => void,
  prefetchedPagesRef: React.MutableRefObject<Set<number>>,
) => {
  useEffect(() => {
    // When any query parameter changes (except page), reset the toast flag
    // and prefetched pages tracking
    setHasToasted(false);
    prefetchedPagesRef.current = new Set([page]);
    
    // This effect now also depends on QUERY_VERSION to ensure cache is invalidated
    // when the schema changes
  }, [
    searchQuery, 
    activeSubcategoryId, 
    selectedRegion, 
    adjustedPageSize, 
    QUERY_VERSION, 
    setHasToasted, 
    prefetchedPagesRef
  ]);
};
